export const UnitConversions = {
  // Temperature
  celsiusToFahrenheit: (celsius: number): number => celsius * 9 / 5 + 32,
  
  // Speed
  metersPerSecondToMph: (mps: number): number => mps * 2.23694,
  metersPerSecondToKnots: (mps: number): number => mps * 1.94384,
  
  // Distance
  kilometersToMiles: (km: number): number => km * 0.621371,
  kilometersToNauticalMiles: (km: number): number => km * 0.539957,
  
  // Gradients
  celsiusPerKmToFahrenheitPerMile: (cpk: number): number => cpk * 2.89682,
  mgPerM3PerKmToMgPerM3PerMile: (mgpk: number): number => mgpk * 1.60934,
  
  // Concentration
  // mg/m³ stays the same as it's a universal scientific unit
  
  // Format helpers
  formatTemperature: (celsius: number): string => 
    `${UnitConversions.celsiusToFahrenheit(celsius).toFixed(1)}°F`,
    
  formatSpeed: (mps: number): string => 
    `${UnitConversions.metersPerSecondToMph(mps).toFixed(1)} mph`,
    
  formatCurrentSpeed: (mps: number): string => 
    `${UnitConversions.metersPerSecondToKnots(mps).toFixed(1)} knots`,
    
  formatDistance: (km: number): string => 
    `${UnitConversions.kilometersToMiles(km).toFixed(1)} mi`,
    
  formatNauticalDistance: (km: number): string => 
    `${UnitConversions.kilometersToNauticalMiles(km).toFixed(1)} nm`,
    
  formatTemperatureGradient: (cpk: number): string => 
    `${UnitConversions.celsiusPerKmToFahrenheitPerMile(cpk).toFixed(2)}°F/mi`,
    
  formatChlorophyllGradient: (mgpk: number): string => 
    `${UnitConversions.mgPerM3PerKmToMgPerM3PerMile(mgpk).toFixed(2)} mg/m³/mi`,
    
  formatChlorophyllConcentration: (mg: number): string => 
    `${mg.toFixed(2)} mg/m³`
};